// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"e41802e3","453":"dae1e556","754":"f1f18043"}[chunkId] + ".chunk.js";
};